import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { kubernetesReactTranslationRef } from '@backstage/plugin-kubernetes-react/alpha';

export const kubernetesReactTranslations = createTranslationResource({
  ref: kubernetesReactTranslationRef,
  translations: {
    en: () => import('./kubernetes-react-en'),
    es: () => import('./kubernetes-react-es'),
  },
});